import { daysDifference } from 'enrollment/utils/date/utils';

export const calcDaysLeft = (
  enrollmentEndsOn: Date,
  dateToday: Date = new Date()
) => {
  if (enrollmentEndsOn) {
    const days = daysDifference(enrollmentEndsOn, dateToday);
    return days + 1;
  }
  return 0;
};
